import { Box } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { FormHelperText } from '@mui/material';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import './style.css'

function CustomPhoneInput(props) {
  const [toggleComp, setToggleComp] = useState(true)
  
  useEffect(()=>{
    setToggleComp(false)
    setTimeout(()=>{
      setToggleComp(true)
    },1)
  },[props?.country])

  return <div style={{position: "relative"}}>
    {props.label && <label className='floatingLablePhone'>
      {props.label}
    </label>}
    {toggleComp && <PhoneInput
      country={'in'}
      countryCodeEditable={false}
      {...props} 
      inputStyle={{
        paddingTop: "17px",
        paddingBottom: "17px",
        height: 'auto',
        ...props.inputStyle
      }}
    />}
    {props.error?<FormHelperText error={true}>{props.helperText}</FormHelperText>: null}
  </div>
}

export default CustomPhoneInput;

CustomPhoneInput.defaultProps = {
  inputStyle: {}
}